module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ack"
  }, [_vm._v("This book is filled with inspired Convergence quilt variations thanks to the generous support of over two hundred quilters who submitted photos for the book. My sincere thanks to these talented people for creating beautiful work and sharing it.")]), _vm._v(" "), _c('p', {
    staticClass: "ack1"
  }, [_vm._v("A special thank you goes to the countless individuals–teachers, leaders, friends, students, colleagues, and family–who, over the years, have encouraged me to pursue my dreams.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94a87c1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0003_pro.vue
// module id = 69
// module chunks = 0